// extracted by mini-css-extract-plugin
export var activePanel = "tabbedContent-module--activePanel--519d5";
export var panel = "tabbedContent-module--panel--cff45";
export var tabGrid = "tabbedContent-module--tabGrid--9f9ad";
export var tabbedContent = "tabbedContent-module--tabbedContent--8b73d";
export var tabsEyebrow = "tabbedContent-module--tabsEyebrow--65ebb";
export var tabsHeadline = "tabbedContent-module--tabsHeadline--69a2a";
export var tabsSubhead = "tabbedContent-module--tabsSubhead--e33d9";